'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaOn = exports.mediaMin = exports.mediaMax = undefined;

var _templateObject = _taggedTemplateLiteral(['\n      @media (max-width: ', 'px) {\n        ', ';\n      }\n    '], ['\n      @media (max-width: ', 'px) {\n        ', ';\n      }\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      @media (min-width: ', 'px) {\n        ', ';\n      }\n    '], ['\n      @media (min-width: ', 'px) {\n        ', ';\n      }\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      @media (min-width: ', 'px) and (max-width: ', 'px) {\n        ', ';\n      }\n    '], ['\n      @media (min-width: ', 'px) and (max-width: ', 'px) {\n        ', ';\n      }\n    ']);

var _styledComponents = require('styled-components');

var _variables = require('./variables');

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// Iterate through the sizes and create a media template
var mediaMax = exports.mediaMax = Object.keys(_variables.deviceSizes).reduce(function (argsAcc, label) {
  var acc = Object.assign({}, argsAcc);
  acc[label] = function () {
    return (0, _styledComponents.css)(_templateObject, _variables.deviceSizes[label] - 1, _styledComponents.css.apply(undefined, arguments));
  };
  return acc;
}, {});

var mediaMin = exports.mediaMin = Object.keys(_variables.deviceSizes).reduce(function (argsAcc, label) {
  var acc = Object.assign({}, argsAcc);
  acc[label] = function () {
    return (0, _styledComponents.css)(_templateObject2, _variables.deviceSizes[label], _styledComponents.css.apply(undefined, arguments));
  };
  return acc;
}, {});

var mediaOn = exports.mediaOn = Object.keys(_variables.deviceSizes).reduce(function (argsAcc, label, i) {
  var acc = Object.assign({}, argsAcc);
  var nextLabel = Object.keys(_variables.deviceSizes)[i + 1];

  acc[label] = function () {
    return (0, _styledComponents.css)(_templateObject3, _variables.deviceSizes[nextLabel] || 0, _variables.deviceSizes[label] - 1, _styledComponents.css.apply(undefined, arguments));
  };
  return acc;
}, {});


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/styles/media.js
// module id = 16
// module chunks = 0